import {SimpleUser} from 'hubbl-shared';
import {getAuthUser} from '../user/getAuthUser';

export const isUserInvited = (
  invitedUsers: SimpleUser[] | undefined,
): boolean => {
  const loggedInUser = getAuthUser();

  if (loggedInUser && invitedUsers) {
    return invitedUsers.some(
      invitedUser => invitedUser.id === loggedInUser.uid,
    );
  } else {
    return false;
  }
};
